import React, { ReactNode } from "react";
import type { IconComponent } from "../../types/ui";
export type BadgeTone = 'green' | 'blue' | 'orange' | 'amber' | 'grey' | 'red' | 'navy' | 'teal';
interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  dot?: boolean;
  icon?: IconComponent;
  className?: string;
}
const TONES: Record<BadgeTone, string> = {
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-600/15',
  blue: 'bg-azure/10 text-[#0e77a6] ring-azure/20',
  orange: 'bg-flame/10 text-[#c25a00] ring-flame/25',
  amber: 'bg-amber-50 text-amber-700 ring-amber-500/30',
  grey: 'bg-slate-100 text-slate-600 ring-slate-500/10',
  red: 'bg-rose-50 text-rose-700 ring-rose-600/15',
  navy: 'bg-navy/[0.06] text-navy ring-navy/10',
  teal: 'bg-deep/10 text-deep ring-deep/20'
};
const DOTS: Record<BadgeTone, string> = {
  green: 'bg-emerald-500',
  blue: 'bg-azure',
  orange: 'bg-flame',
  amber: 'bg-amber-500',
  grey: 'bg-slate-400',
  red: 'bg-rose-500',
  navy: 'bg-navy',
  teal: 'bg-deep'
};
export function Badge({
  tone = 'grey',
  children,
  dot,
  icon: Icon,
  className = ''
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${TONES[tone]} ${className}`} data-id="element-737" data-mp="14kvw06c1pef5">
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${DOTS[tone]}`} aria-hidden="true" data-id="element-738" data-mp="1ejl2z42elegm" />}
      {Icon && <Icon className="h-3 w-3" aria-hidden="true" data-id="element-739" data-mp="gwcmxol68xm0" />}
      {children}
    </span>;
}